import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import IncentiveForm from './IncentiveForm'

import { updateIncentive } from '../services'
import { handleError } from '../../../helpers'

export default function EditIncentiveModal({ visible, onClose, incentive, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			...incentive,
			is_public: incentive.is_public.toString()
		}
	})

	const onSubmit = values => {
		updateIncentive(incentive.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(handleError)
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar incentivo</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<IncentiveForm 
						register={register}
						errors={errors}
						onlyEditable
					/>
					<Button color="primary" type="submit">
						Actualizar incentivo
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}